import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TCreateAppleWalletProvisionRequest,
  TCreateAppleWalletProvisionResponse,
} from "./createAppleWalletProvision.schema";

export const createAppleWalletProvision = (axios: IAxiosInstance) => {
  return async (
    data: TCreateAppleWalletProvisionRequest
  ): Promise<IApiResponse<TCreateAppleWalletProvisionResponse>> => {
    const { paycard_id, ...rest } = data;
    const response = await axios.noRetry.post<
      IApiResponse<TCreateAppleWalletProvisionResponse>
    >(`/api/paycards/${paycard_id}/apple-wallet-provision`, rest);
    return response.data;
  };
};
